var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserEditColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "78468D31-A83A-49DD-A1FB-D557E4FE1683") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M155.721875,289 C156.41875,289.31875 157.1875,289.5 158,289.5 C158.8125,289.5 159.584375,289.31875 160.278125,289 L160.278125,289 L160.8,289 C162.046875,289 163.15625,289.55625 163.921875,290.421875 L163.921875,290.421875 L161.50625,292.8375 L161.259375,293.084375 L161.221875,293.43125 L161.009375,295.334375 C160.984375,295.5625 161.015625,295.7875 161.090625,296 L161.090625,296 L152.5,296 C151.671875,296 151,295.328125 151,294.5 L151,294.5 L151,293.2 C151,290.88125 152.88125,289 155.2,289 L155.2,289 Z M166.525,289.234375 L168.765625,291.475 L164.45625,295.784375 L162.553125,295.996875 C162.2375,296.034375 161.96875,295.765625 162.003125,295.446875 L162.003125,295.446875 L162.215625,293.540625 L166.525,289.234375 Z M168.540625,287.21875 C168.83125,286.928125 169.30625,286.928125 169.596875,287.21875 L169.596875,287.21875 L170.78125,288.403125 C171.071875,288.696875 171.071875,289.16875 170.78125,289.4625 L170.78125,289.4625 L169.475,290.76875 L167.23125,288.528125 L167.359375,288.4 Z M158,280 C160.209375,280 162,281.790625 162,284 C162,286.209375 160.209375,288 158,288 C155.790625,288 154,286.209375 154,284 C154,281.790625 155.790625,280 158,280 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-151.000000, -280.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "user-edit",
    fill: "#8B88FF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserEditColored);
export default ForwardRef;